import styled from "@emotion/styled"
import { InputAdornment, InputBaseProps, TextField } from "@mui/material"
import colors from "theme/colors"

const Asterisk = styled.span<{ $marginBottom?: number; $color: string }>`
  color: ${(p) => p.$color};
  margin-bottom: ${(p) => (p.$marginBottom ? `${p.$marginBottom}px` : "0px")};
  width: 4px;
`

const StyledTextField = styled(TextField)`
  .MuiInputBase-root {
    height: 36px;
  }
  margin-bottom: 29px;
  input {
    font-size: 18px;
    line-height: 24px;
    ::placeholder {
      font-size: 18px;
      line-height: 24px;
    }
  }
  .MuiFormHelperText-root {
    font-size: 14px;
    line-height: 20px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    .MuiInputBase-root {
      height: 24px;
    }
    margin-bottom: 19px;
    input {
      font-size: 12px;
      line-height: 16px;
      ::placeholder {
        font-size: 12px;
        line-height: 16px;
      }
    }
    .MuiFormHelperText-root {
      font-size: 10px;
      line-height: 18px;
    }
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    margin-bottom: 29px;
    .MuiInputBase-root {
      height: 36px;
    }
    input {
      font-size: 18px;
      line-height: 24px;
      ::placeholder {
        font-size: 18px;
        line-height: 24px;
      }
    }
    .MuiFormHelperText-root {
      font-size: 12px;
      line-height: 20px;
    }
  }
`

type FormInputProps = {
  field: object
  error?: string | undefined
  placeholder: string
  type: string
  required?: boolean
  inputProps?: InputBaseProps
  fullWidth?: boolean
}

function FormInput({
  field,
  error,
  placeholder,
  type = "text",
  required = false,
  inputProps,
  fullWidth = false,
}: FormInputProps) {
  return (
    <StyledTextField
      {...field}
      placeholder={placeholder}
      helperText={error}
      variant="standard"
      error={error ? true : false}
      fullWidth={fullWidth}
      type={type}
      InputProps={{
        ...inputProps,
        startAdornment: required && (
          <InputAdornment position="start">
            <Asterisk
              $marginBottom={28}
              $color={error ? colors.darkRed : colors.blue}
            >
              *
            </Asterisk>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default FormInput
